import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetNotifications_notificationConnections_notifications_resource_Comment as GetNotificationResourceCommentGenerated,
  GetNotifications_notificationConnections_notifications_resource_Comment_target_Task as GetNotificationResourceCommentTargetGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity as GetNotificationResourceTaskActivityGenerated,
  GetNotifications_notificationConnections_notifications_resource_Task as GetNotificationResourceTaskGenerated,
  GetNotifications as GetNotificationsGenerated,
  GetNotificationsVariables as GetNotificationsVariablesGenerated,
  GetNotifications_notificationConnections_notifications as GetUserNotificationGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_task_parentTask as GetUserNotificationParentTaskGenerated,
  GetNotifications_notificationConnections_notifications_resource_CleanActivity_cleaningRequest as GetUserNotificationResourceCleanActivityCleaningRequestGenerated,
  GetNotifications_notificationConnections_notifications_resource_CleanActivity as GetUserNotificationResourceCleanActivityGenerated, // PLS NO
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_AssigneeIdChangeMetadata as GetUserNotificationResourceTaskActivityMetadataAssigneeIdChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_ChangedTagMetadata as GetUserNotificationResourceTaskActivityMetadataChangedTagMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_DueAtChangeMetadata as GetUserNotificationResourceTaskActivityMetadataDueAtChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_EtaChangeMetadata as GetUserNotificationResourceTaskActivityMetadataEtaChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_NameChangeMetadata as GetUserNotificationResourceTaskActivityMetadataNameChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_PriorityChangeMetadata as GetUserNotificationResourceTaskActivityMetadataPriorityChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_RecurrenceChangeMetadata as GetUserNotificationResourceTaskActivityMetadataRecurrenceChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_ScheduleChangeMetadata as GetUserNotificationResourceTaskActivityMetadataScheduleChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_metadata_StatusChangeMetadata as GetUserNotificationResourceTaskActivityMetadataStatusChangeMetadataGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_user as GetUserNotificationResourceUserGenerated,
  GetNotifications_notificationConnections_notifications_resource_TaskActivity_task as GetUserNotificationTaskGenerated,
} from "core/queries/__generated__/GetNotifications";

export interface GetNotificationsVariables
  extends GetNotificationsVariablesGenerated {}
export interface GetNotificationsResponse extends GetNotificationsGenerated {}
export interface GetUserNotification extends GetUserNotificationGenerated {}
export interface GetUserNotificationTask
  extends GetUserNotificationTaskGenerated {}
export interface GetUserNotificationParentTask
  extends GetUserNotificationParentTaskGenerated {}
export interface GetUserNotificationResourceUser
  extends GetUserNotificationResourceUserGenerated {}

export interface GetUserNotificationResourceCleanActivity
  extends GetUserNotificationResourceCleanActivityGenerated {}

export interface GetNotificationResourceCommentTarget
  extends GetNotificationResourceCommentTargetGenerated {}

export interface GetUserNotificationResourceComment
  extends GetNotificationResourceCommentGenerated {}

export interface GetUserNotificationResourceTask
  extends GetNotificationResourceTaskGenerated {}

export interface GetUserNotificationResourceTaskActivity
  extends GetNotificationResourceTaskActivityGenerated {}

export interface GetUserNotificationResourceCleanActivityCleaningRequest
  extends GetUserNotificationResourceCleanActivityCleaningRequestGenerated {}

export interface GetUserNotificationResourceTaskActivityMetadataAssigneeIdChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataAssigneeIdChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataChangedTagMetadata
  extends GetUserNotificationResourceTaskActivityMetadataChangedTagMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataDueAtChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataDueAtChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataEtaChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataEtaChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataNameChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataNameChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataPriorityChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataPriorityChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataRecurrenceChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataRecurrenceChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataScheduleChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataScheduleChangeMetadataGenerated {}
export interface GetUserNotificationResourceTaskActivityMetadataStatusChangeMetadata
  extends GetUserNotificationResourceTaskActivityMetadataStatusChangeMetadataGenerated {}

export const getNotifications = gql`
  fragment NotificationTaskFragment on Task {
    id
    assignee {
      id
    }
    author {
      id
      avatar: profilePicture {
        id
        url
      }
      name
    }
    building {
      id
      shortInternalRef
    }
    channel
    cufSpace {
      id
      internalRef
    }
    dueAt
    id
    name
    subjectType
    type
    unit {
      id
      shortInternalRef
    }
  }
  query GetNotifications($pagination: Pagination!) {
    notificationConnections(pagination: $pagination) {
      total
      hasMore
      cursor
      notifications {
        activityTime
        archived
        id
        reasons
        resource {
          id
          ... on Comment {
            author {
              avatar: profilePicture {
                id
                url
              }
              id
              name
            }
            body
            targetType
            target {
              id
              ... on Task {
                ...NotificationTaskFragment
              }
            }
          }
          ... on Task {
            ...NotificationTaskFragment
          }
          ... on CleanActivity {
            id
            title
            body
            reason
            activityTime
            activityType
            shuffleStatus
            obsolete
            cleaningRequest {
              id
              cleaning {
                id
                assignees {
                  id
                }
                scheduledEnd
                scheduledStart
              }
              company {
                id
              }
              endAt
              unit {
                id
                building {
                  id
                }
                shortInternalRef
              }
              space {
                id
                building {
                  id
                }
                internalRef
              }
              startAt
              status
            }
            user {
              id
              avatar: profilePicture {
                id
                url
              }
              name
            }
          }
          ... on TaskActivity {
            activityType
            body
            user {
              avatar: profilePicture {
                id
                url
              }
              id
              name
            }
            metadata {
              # Please keep this in sync with GetTaskComments metadata.
              # Bad things can happen if you don't. https://app.asana.com/0/1135692148853775/1201719083791219
              ... on AssigneeIdChangeMetadata {
                id
                newAssignee {
                  id
                  name
                }
                prevAssignee {
                  id
                  name
                }
              }
              ... on ChangedTagMetadata {
                id
                tag {
                  id
                  name
                }
              }
              ... on DueAtChangeMetadata {
                id
                newDueAt
                prevDueAt
              }
              ... on EtaChangeMetadata {
                id
                newEta
                reason
              }
              ... on NameChangeMetadata {
                id
                newName
                previousName
              }
              ... on PriorityChangeMetadata {
                id
                newPriority
                previousPriority
              }
              ... on RecurrenceChangeMetadata {
                id
                daysOfWeek
              }
              ... on ScheduleChangeMetadata {
                id
                reason
                prevAssignees {
                  id
                  name
                }
              }
              ... on StatusChangeMetadata {
                id
                newStatus
                prevStatus
              }
            }
            task {
              id
              ...NotificationTaskFragment
              parentTask {
                id
                ...NotificationTaskFragment
              }
            }
          }
        }
      }
    }
  }
`;

export interface UseGetNotificationsQueryOptions {
  pollInterval?: number;
  skip?: boolean;
  variables: GetNotificationsVariables;
}
export const useGetNotificationsQuery = ({
  pollInterval,
  skip = false,
  variables,
}: UseGetNotificationsQueryOptions) =>
  useQuery<GetNotificationsResponse, GetNotificationsVariables>(
    getNotifications,
    {
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      pollInterval,
      skip,
      variables,
    },
  );

export interface UseGetNotificationsOptions
  extends UseGetNotificationsQueryOptions {
  variables: Omit<GetNotificationsVariables, "userId">;
}

export const useGetNotifications = ({
  pollInterval,
  skip = false,
  variables,
}: UseGetNotificationsOptions) => {
  const { data, fetchMore, loading, networkStatus, refetch } =
    useGetNotificationsQuery({
      pollInterval,
      skip,
      variables: {
        ...variables,
      },
    });
  const notificationConnections = data && data.notificationConnections;
  const notifications =
    (notificationConnections && notificationConnections.notifications) || [];
  return {
    fetchMore,
    loading,
    networkStatus,
    notificationConnections,
    notifications,
    refetch,
  };
};
